import { useDatabase } from '../../contexts/DatabaseContext';
import { CircleStackIcon } from '@heroicons/react/24/outline';

export default function DatabaseSelector({ className = '' }) {
  const { databases, databaseSlug, setDatabase, isLoading } = useDatabase();

  if (isLoading || databases.length <= 1) return null;

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <CircleStackIcon className="w-4 h-4 text-text-muted" />
      <select
        value={databaseSlug || ''}
        onChange={(e) => setDatabase(e.target.value)}
        className="px-3 py-1.5 text-sm bg-white dark:bg-background-gray border border-border-light dark:border-border rounded-lg focus:outline-none focus:ring-1 focus:ring-brand-primary text-text-primary-light dark:text-text-primary cursor-pointer"
      >
        {databases.map((db) => (
          <option key={db.id} value={db.slug}>
            {db.name}
          </option>
        ))}
      </select>
    </div>
  );
}
